export enum CaseStudyCategory {
	ShelfSystem = "ShelfSystem",
	DurableContainers = "DurableContainers",
	SteelPlatforms = "SteelPlatforms",
	StorageTowers = "StorageTowers",
	Agv = "Agv",
}
